export enum EMoveDirection {
  ToTop = 'toTop',
  Up = 'up',
  Down = 'down',
  ToBottom = 'toBottom',
}
